import type {LeadUpdateEvent} from './types';

/* Takes in a lead updated event and dispatches an event that will be ingested
by the useLeadUpdateRefetch hook */
export const refetchForEvent = (event: LeadUpdateEvent) => {
    window.dispatchEvent(new CustomEvent('leadUpdated', {detail: {type: event}}));
};
